// extracted by mini-css-extract-plugin
export default {"inlineCaption":"inlineCaption--urivK"};